import {
  addExpenseApi,
  getCommonExpenseApi,
  getUserAccountList,
  handleKeyDown,
  makePaymentApi,
  uploadFiles,
  venderDropdownApi,
} from "_services";
import { getConsignorListData } from "_services/accountsServices/consignorServices";
import { getSupplierListData } from "_services/accountsServices/supplierServices";
import { getDriverDropdownListData, getFuelApi } from "_services/dropdownServices/dropdownService";

import {
  CommonCanvas,
  CommonDatePicker,
  CommonInput,
  CommonModal,
  CustomSelect,
  SkeletonInput,
} from "components";
import { UserContext } from "context";
import { addTransationConsignor, addTransationFreight } from "features";
import { errorSchema, utils } from "helper";
import AddEditModal from "modals/AddEditModal";
import React, { useCallback, useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { IoCloseCircle } from "react-icons/io5";
import { useDispatch } from "react-redux";
import StorageService from "utils/StorageServices";



const ExpenseMarket = (props) => {
  const {
    tripId,
    modalType,
    closeModal,
    callBackFreight,
    isOpen,
    detailsProps,
    callBackApiCall,
    setIsOpenPayNow,
  } = props;

  const initiFrom = {
    category: "",
    sub_category: "",
    expense_category: "",
    amount: "",
    txn_date: new Date(),
    account_category: "",
    account_sub_category: "",
    account_id: "",
    description: "",
    vendor_type: "",
    // vendor_account: "",
    lr_id: "",
    trip_id: tripId,
    branch_id: "",
    company_id: StorageService.getCompanyId(),
    vehicle_id: "",
    file: [],
    vendor_bank_account: "",
    vendor_id: "",
  };

  console.log("detailsProps", detailsProps)

  const { masterData, globTripDetails,bankDetails } = useContext(UserContext);
  const dispatch = useDispatch();
  const [form, setForm] = useState(initiFrom);
  const [formError, setFormError] = useState("");
  const [expenseTypeList, setExpenseTypeList] = useState([]);
  const [expenseAccount, setExpenseAccount] = useState([]);
  const [expenseList, setExpenseList] = useState([]);
  const [venderList, setVenderList] = useState([]);
  const [supplierList, setSupplierList] = useState([]);
  const [partyList, setPartyList] = useState([]);
  const [accountType, setAccountType] = useState();
  const [accountList, setAccountList] = useState([]);
  const [allList, setAllList] = useState([]);
  const [isLoadding, setIsLoadding] = useState(false);
  const [accountLoading, setAccountLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isLoadingSave, setIsLoadingSave] = useState(false);
  const [reciptList, setReciptList] = useState([]);
  const [expenseDetails, setExpenseDetails] = useState("");
  const [receiptDetails, setReceiptDetails] = useState("");
  const [commExpenseList, setCommExpenseList] = useState([]);
  const [isOpenFuelModal, setIsOpenFuelModal] = useState(false);
  const balance =
    props?.transactionList?.freight_summary?.freight_summary?.balance;

  const toPayList = masterData?.vendor_type_list.map((item) => {
    return { label: item?.name, value: item?.id }
  });
  const [driverList, setDriverList] = useState([]);
  const [fuelStationList, setFuelStationList] = useState([]);

  const listMap = {
    1: { label: "Select Supplier", list: supplierList },
    2: { label: "Select Party", list: partyList },
    3: { label: "Select Driver", list: driverList },
    4: { label: "Select Vendor", list: venderList },
    5: { label: "Select Fuel Station", list: fuelStationList },
    6: { label: "Select Fuel Card", list: [] },
    7: { label: "Select Fastag", list: [] },
    8: { label: "Select Staff", list: [] },
  };


  const optionMap = masterData?.vendor_type_list.reduce((acc, item) => {
    acc[item.id] = {
      label: listMap[item.id]?.label || `Select ${item.name}`,
      name: "vendor_id",
      list: listMap[item.id]?.list || [],
      value: form?.vendor_id,
    };
    return acc;
  }, {});

  const orderOfVender = [4, 2, 1, 3, 5, 6, 7, 8];;
  const sortedData = toPayList.sort(
    (a, b) => orderOfVender.indexOf(a.value) - orderOfVender.indexOf(b.value)
  );

  const visibleOptions = sortedData.filter(opt =>
    [1, 2, 4].includes(opt.value)
  );

  const dropdownOptions = sortedData.filter(opt =>
    ![1, 2, 4, 6, 7, 8].includes(opt.value)
  );

  const isSelected = (opt) => form?.vendor_type === opt.value;

  useEffect(() => {
    getMasterFreight();
    // getVenderHandler();
  }, []);

  useEffect(() => {
    if (
      (form?.account_sub_category && form?.account_category,
        expenseAccount.length)
    ) {
      // if (form?.account_id == "") {
      // getAccountListHandler();
      // }
    }
  }, [
    form?.account_sub_category,
    form?.account_category,
    expenseAccount,
    form?.account_id,
  ]);

  useEffect(() => {
    if (accountType) {
      setForm({ ...form, account_id: "" });
    }
  }, [accountType]);

  useEffect(() => {
    setAllList([...partyList, ...supplierList, ...venderList]);
  }, [partyList, supplierList, venderList]);

  const getMasterFreight = async () => {
    try {
      const details = masterData?.supplier_other_charges
        ?.sub_type?.map((item) => {
          return {
            label: item?.name,
            value: item?.id,
            id: item?._id,
            status: item?.status,
            category_id: masterData?.supplier_other_charges
              ?.id,
            type: masterData?.supplier_other_charges
              ?.type,
          };
        });

      const detailsAccount =
        masterData?.market_account_category?.sub_category
          ?.filter((k) => k.id !== 10)
          ?.map((item) => {
            return {
              label: item?.name,
              value: item?.id,
              category_id: masterData?.market_account_category?.id,
            };
          })
          ?.concat({
            label: "To Pay",
            value: 1,
            category_id: masterData?.market_account_category?.id,
          });

      const order = [1, 3, 2, 27, 14, 28];;
      const sortedData = detailsAccount.sort(
        (a, b) => order.indexOf(a.value) - order.indexOf(b.value)
      );

      const detailsAccountOwn =
        masterData?.own_account_category?.sub_category
          ?.filter((k) => k.id !== 10)
          ?.map((item) => {
            return {
              label: item?.name,
              value: item?.id,
              category_id: masterData?.own_account_category?.id,
            };
          })
          ?.concat({
            label: "To Pay",
            value: 1,
            category_id: masterData?.own_account_category?.id,
          });



      const order1 = [1, 11, 3, 2, 27, 14, 28];
      const sortedData1 = detailsAccountOwn.sort(
        (a, b) => order1.indexOf(a.value) - order1.indexOf(b.value)
      );


      if (sortedData && details) {
        setForm({
          ...form,
          trip_id: detailsProps?.trip?._id,
          category: detailsProps?.type,
          sub_category: detailsProps?.sub_type,
          account_category: detailsProps?.payment_mode?.account_category,
          account_sub_category: detailsProps?.payment_mode?.account_sub_category,
          account_id: detailsProps?.payment_mode?.account?._id,
          amount: detailsProps?.total_amount,
          txn_date: new Date(detailsProps?.date),
          description: detailsProps?.description,
          file: detailsProps?.file,
          vendor_type: detailsProps?.vendor_type,
          vendor_id: detailsProps?.vendor_detail?._id,
          vendor_bank_account: detailsProps?.vendor_bank_account?._id,
          expense_category: detailsProps?.categories[0]?.category?._id

        });


        setExpenseTypeList(details);
        setExpenseAccount(
          sortedData
        );
      }
      // }
    } catch { }
  };

  const getVenderHandler = async () => {
    try {
      const res = await venderDropdownApi({
        company_id: StorageService.getCompanyId(),
        firm_id: StorageService.getFirmId(),
        offset: 1,
        limit: 2000,
      });
      const resSupplier = await getSupplierListData({
        company_id: StorageService.getCompanyId(),
        firm_id: StorageService.getFirmId(),
        offset: 1,
        limit: 2000,
      });

      const resDriver = await getDriverDropdownListData({
        company_id: StorageService.getCompanyId(),
        firm_id: StorageService.getFirmId(),
        offset: 1,
        limit: 2000,
      });
      const resFuelStation = await getFuelApi({
        company_id: StorageService.getCompanyId(),
        offset: 1,
        limit: 2000,
      });

      const resParty = await getConsignorListData({
        company_id: StorageService.getCompanyId(),
        firm_id: StorageService.getFirmId(),
        offset: 1,
        limit: 2000,
      });

      if (res?.responseCode === 200) {
        const details = res?.data?.vendor_list?.map((item) => {
          return {
            label: item?.name,
            value: item?._id,
          };
        });

        setVenderList(details);
      } else {
      }

      if (resSupplier?.responseCode === 200) {
        const details = resSupplier?.data?.supplier_list?.map((item) => {
          return {
            label: item?.name,
            value: item?._id,
          };
        });

        setSupplierList(details);
      } else {
      }
      if (resParty?.responseCode === 200) {
        const details = resParty?.data?.consignor_list?.map((item) => {
          return {
            label: item?.name,
            value: item?._id,
          };
        });

        setPartyList(details);
      } else {
      }

      if (resDriver?.responseCode === 200) {
        const details = resDriver?.data?.driver_list?.filter((item) => item?.driver_type == 1).map((item) => {
          return {
            label: item?.name,
            value: item?._id,
          };
        });

        setDriverList(details);
      } else {
      }
      if (resFuelStation?.responseCode === 200) {
        const details = resFuelStation?.data?.fuelstation_list?.map((item) => {
          return {
            label: item?.name,
            value: item?._id,
          };
        });

        setFuelStationList(details);
      } else {
      }
    } catch (error) {
    }
  };

  // useEffect(() => {
  //   if (form?.sub_category) {
  //     // getCommonExpense(form?.sub_category);
  //     handleOnChange("expense_category", "");
  //   }
  // }, [form?.sub_category]);

  const modifyExpenseTypeList = useCallback(() => {
    if (form?.sub_category == 1) {
      const filtermode = expenseAccount.filter((item) => item.value != 1);
      return [{ label: 'To Pay', value: 1, category_id: 1 }, ...filtermode]
    } else {
      const filtermode = expenseAccount.filter((item) => item.value != 1);

      return [{ label: 'To Receive', value: 1, category_id: 1 }, ...filtermode]
    }
  }, [form?.sub_category]);

  const getCommonExpense = async (expense) => {
    try {
      const payload = {
        company_id: StorageService.getCompanyId(),
        category_id: expense == 1 ? 5 : 4,
        sub_category_id: expense == 1 ? 3 : 2,
      };
      const res = await getCommonExpenseApi(payload);

      if (res?.responseCode === 200) {
        const details = res?.data?.categories?.map((item) => {
          return {
            ...item,
            label: item?.name,
            value: item?._id,
          };
        });

        setForm({
          ...form,

          expense_category: detailsProps?.categories[0]?.category?._id
        });
        setCommExpenseList(details);
        setExpenseDetails(res?.data);
      } else {
      }
    } catch (error) { }
  };

  const getAccountListHandler = async () => {
    setAccountLoading(true);
    try {
      const res = await getUserAccountList({
        company_id: StorageService?.getCompanyId(),
        category_id: parseInt(form?.account_category),
        sub_category_id: parseInt(form?.account_sub_category),
      });

      if (res?.responseCode === 200) {
        setAccountLoading(false);
        const details = res?.data?.account_list?.map((item) => {
          return {
            ...item,
            label: item?.name,
            value: item?._id,
          };
        });
        setAccountList(details);
        if (form?.account_id == "") {
          handleOnChange("account_id", details[0].value);
        }
        // setForm({ ...form, account_id: details[0].value });
        // handleOnChange("account_id", details[0].value);
      } else {
        setAccountLoading(false);
        setAccountList([]);
      }
    } catch (error) {
      setAccountList([]);
    }
  };

  const handleOnChange = async (name, value) => {
    const stateObj = {
      ...form,
      [name]: value,
    };
    setForm(stateObj);

    if (!!formError) {
      const validationResult = await utils.checkFormError(
        { ...stateObj },
        errorSchema.addClaimOwnSchema
      );
      if (validationResult === true) {
        setFormError("");
      } else {
        setFormError(validationResult);
      }
    }
  };

  const onSubmitExpense = async (approve) => {
    const validationResult = await utils.checkFormError(
      { ...form },
      errorSchema.addClaimOwnSchema
    );

    const payloadforSupplier = {
      company_id: form?.company_id,
      voucher_id: detailsProps?._id,
      date: utils.convertToISO(form?.txn_date, true),
      description: form?.description,
      expense_category: form?.expense_category,
      account_category: form?.account_category
        ? parseInt(form?.account_category)
        : "",
      account_sub_category: form?.account_sub_category
        ? parseInt(form?.account_sub_category)
        : "",
      account_id: form?.account_id ? form?.account_id : "",
      vendor_type: form?.vendor_type ? parseInt(form?.vendor_type) : "",
      vendor_id: form?.vendor_id ? form?.vendor_id : "",
      vendor_bank_account: form?.vendor_bank_account ? form?.vendor_bank_account : "",
      old_account_id: detailsProps?.payment_mode?.account?._id,
    };

    if (validationResult === true) {
      if (form?.account_category == 1 && form?.account_sub_category == 28) {
        setIsOpenPayNow(true)
      } else {
        try {
          setIsLoadding(true)
          const res = await makePaymentApi(payloadforSupplier)

          if (res?.responseCode === 200) {
            setIsLoadding(false)
            closeModal();
            callBackApiCall(true)
          } else {
            setIsLoadding(false);

          }
        } catch {
          setIsLoadding(false);

        }
      }
    } else {
      setFormError(validationResult);
    }
  };


  const modifyProps = {
    ...props,
    isLoadding: isLoadding,
    disabled: isLoadding,
    onSubmit: onSubmitExpense,

  };

  const handleFileChange = async (e) => {
    if (
      e?.target?.files[0]?.type === "image/gif" ||
      e?.target?.files[0]?.type === "image/jpeg" ||
      e?.target?.files[0]?.type === "image/png"
    ) {
      setLoading(true);
      try {
        const formData = new FormData();
        formData.append("file", e?.target?.files[0]);
        const res = await uploadFiles(formData);
        if (res?.responseCode === 200) {
          var fileArray = [];
          fileArray.push(...form?.file, {
            filename: res?.data?.filename,
            path: res?.data?.path,
          });
          handleOnChange("file", fileArray);
          // setFormValue((s) => ({ ...s, file: fileArray }));
          setLoading(false);
          toast.success("Document added ");
        }
      } catch (error) {
        setLoading(false);
      }
    } else {
      toast.error("Invalid file, choose jpeg/png images");
    }
  };

  const documentRemove = (index) => {
    const newFromIput = [...form?.file];

    newFromIput.splice(index, 1);

    setForm({ ...form, file: newFromIput });
  };

  const isExpense = form?.sub_category == 1;
  const categoryLabel = isExpense ? "Expense Category" : "Receipt Category";
  const categoryPlace = isExpense
    ? "Select Expense Category"
    : "Select Receipt Category";
  const categoryOptions = commExpenseList || [{ label: "", value: "" }];
  const selectedCategory = commExpenseList?.find(
    (i) => i.value === form?.expense_category
  );
  const selectedPartyCategory = commExpenseList?.find(
    (i) => i.value === form?.party_expense_category
  );
  const callBackApi = (data) => {
    // getCommonExpense(form?.sub_category);
    handleOnChange("expense_category", data?.category?._id);
    callBackFreight();
  };

  const addExpenseHandle = (data) => {
    setIsOpenFuelModal(true);
  };

  let openZoneModal = {
    isOpen: isOpenFuelModal,
    closeModal: (e) => setIsOpenFuelModal(false),
    // nextModal: (e) => submitUpdateData(e),
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle:
      form?.sub_category == 1 ? "Add Trip Expenses" : "Add Trip Receipt",
    submitTitle:
      form?.sub_category == 1 ? "Add Trip Expenses" : "Add Trip Receipt",
    footerPart: true,
    label: form?.sub_category == 1 ? "Expenses Name" : "Receipt Name",
    placeholder:
      form?.sub_category == 1 ? "Enter Expenses Name" : "Enter Receipt Name",
    ApiPoint: addExpenseApi,
    callBackApi: callBackApi,
    payloadData: {
      category_id: (form?.sub_category == 1) == 1 ? 5 : 4,
      sub_category_id: (form?.sub_category == 1) == 1 ? 3 : 2,
    },
    titleName: "Trip",
  };


  return (
    <div>
      <CommonCanvas {...modifyProps}>
        <div className="offcanvas-body">
          <div className="_lrCl_offCavBody __otr_expCanva ">
            <div className="_othrExp_recBx">
              <div className="checkBx_lv" style={{ marginBottom: '12px' }}>
                <div className="singleDiv">
                  <CommonDatePicker
                    name="date"
                    label="Transaction Date"
                    startDate={form?.txn_date}
                    setStartDate={(data) => {
                      handleOnChange("txn_date", data);
                    }}
                    error={formError?.txn_date}
                    focus={!!formError?.txn_date}
                  />
                </div>
              </div>

              <div className="checkBx_lv" style={{ marginBottom: '12px' }}>
                {expenseTypeList.map((i) => {
                  return (
                    <div className="_dualCheckr_bx">
                      <input
                        className="form-check-input"
                        id={i?.value}
                        type="radio"
                        name="sub_category"
                        checked={i.value == form.sub_category}
                        value={i.value}
                        onChange={({ target: { name, value } }) =>
                          handleOnChange(name, value)
                        }
                        disabled
                      />
                      <label for={i?.value} className="form-check-label">
                        {i?.label}
                      </label>
                    </div>
                  );
                })}
                {/* <div className="_dualCheckr_bx" >
                          <input className="form-check-input" id="receipt" type="radio" name="otrExpRec" value="2" />
                          <label for="receipt" className="form-check-label">Receipt</label>
                        </div> */}
              </div>
              <div className="_clPay_flex">
                <div className="singleDiv">
                  <CustomSelect
                    label={categoryLabel}
                    options={categoryOptions}
                    placeholder={categoryPlace}
                    onSelect={(data) =>
                      handleOnChange("expense_category", data.value)
                    }
                    // value={selectedCategory || { label: "", value: "" }}
                    value={{ label: detailsProps?.categories[0]?.category?.name, value: detailsProps?.categories[0]?.category?._id }}
                    focus={!!formError?.expense_category}
                    error={formError?.expense_category}
                    isAddButton={true}
                    addButtonAction={addExpenseHandle}
                    disabled
                  />
                </div>



                <div className="singleDiv">
                  <CommonInput
                    type="text"
                    label="Description"
                    placeholder="Description"
                    name="description"
                    value={form?.description}
                    onChange={({ target: { name, value } }) => {
                      handleOnChange(name, value);
                    }}
                    focus={!!formError?.description}
                    error={formError.description}
                    disabled
                  />
                </div>
                <div className="singleDiv">
                  <CommonInput
                    type="text"
                    label="Amount (₹)"
                    placeholder="Amount (₹)"
                    name="amount"
                    value={form.amount}
                    onChange={({ target: { name, value } }) => {
                      // if (validateInput(value ? value : 0)) {
                      handleOnChange(name, value);

                      // }
                    }}
                    disabled
                    maxLength={10}
                    onKeyDown={handleKeyDown}
                    focus={!!formError?.amount}
                    error={formError.amount}
                  />
                </div>





                {/* <div className="singleDiv">
                  <CustomSelect
                    label="Select Vender"
                    options={venderList}
                    onSelect={(data) => {
                      handleOnChange("vendor_account", data.value);
                    }}
                    placeholder={"Select Vender"}
                    value={
                      form?.vendor_account
                        ? venderList?.find((i) => i.value == form?.vendor_account)
                        : { label: "", value: "" }
                    }
                    disabled
                  />
                </div> */}


              </div>
            </div>

            <div className="_othrExp_recBx">
              <div className="_clPay_flex">
                <div className="singleDiv">
                  <div className="_payMode_hed">
                    <h4>Payment Mode </h4>
                    {modifyExpenseTypeList().map((i) => (
                      <button
                        className={`_baseSpan ${i?.value == detailsProps?.payment_mode?.account_sub_category
                          ? ""
                          : "_bspDisable"
                          }`}
                        // disabled={accountLoading }
                        disabled={true}
                        name="account_sub_category"
                        value={i.value}
                        onClick={({ target: { name, value } }) => {
                          handleOnChange(name, value);
                          setAccountType(value);
                        }}
                      >
                        {i.label}
                      </button>
                    ))}
                    {/* <button className="_baseSpan _bspDisable" >Balance</button> */}
                  </div>
                </div>

                {form?.account_sub_category != 11 && form?.account_sub_category != 1 && (
                  <>
                    {!accountLoading ? (
                      <div className="singleDiv">
                        <CustomSelect
                          label="Select Account"
                          name="account_id"
                          onSelect={(data) => {
                            handleOnChange("account_id", data.value);
                          }}
                          // value={
                          //   form?.account_id
                          //     ? accountList?.find(
                          //       (i) => i.value == form?.account_id
                          //     )
                          //     : { label: "", value: "" }
                          // }
                          value={{ label: detailsProps?.payment_mode?.account?.name, value: detailsProps?.payment_mode?.account?._id }}
                          options={accountList}
                          focus={!!formError?.account_id}
                          error={formError.account_id}
                          disabled={true}

                        />
                      </div>
                    ) : (
                      <SkeletonInput isLoading={accountLoading} />
                    )}
                  </>
                )}
              </div>
            </div>
            {(form?.vendor_id || form?.account_sub_category != 11) && <div className="_othrExp_recBx">
              <div className="__vendorBxs">
                <div className="_clPay_flex">
                  <h4>{form?.sub_category == 1 ? "Vendor Details" : "Customer Details"}</h4>
                  <div className='__splNw_tabBx' style={{ marginBottom: '5px', marginTop: '-5px' }}>
                    {visibleOptions.map((opt) => {
                      return (

                        <button
                          key={opt.value}
                          className={`__splBtns ${opt.value === form?.vendor_type ? '__splActive' : ''}`}
                          // onClick={() => {
                          //   setSelectedOption(opt)
                          //   handleOnChange("vendor_type", opt.value);
                          // }}
                          disabled={true}

                        >
                          {opt.label}
                        </button>


                      )
                    })}

                    <div className={`${dropdownOptions.find((opt) => opt.value === form?.vendor_type) ? "__splSelectBx __splActive" : "__splSelectBx"} `}>

                      <CustomSelect
                        key={form?.vendor_type}
                        options={dropdownOptions}
                        value={
                          dropdownOptions.find((opt) => opt.value === form?.vendor_type) || null
                        }
                        // onSelect={(selected) => {
                        //   setSelectedOption(selected)
                        //   handleOnChange("vendor_type", selected.value);
                        // }
                        // }
                        placeholder={
                          dropdownOptions.find((opt) => opt.value === form?.vendor_type)?.label
                          || 'More'
                        }
                        disabled={true}
                      />
                    </div>
                  </div>
                  <div className="singleDiv">
                    <CustomSelect
                      label={optionMap[form?.vendor_type]?.label}
                      options={optionMap[form?.vendor_type]?.list || []}
                      name={optionMap[form?.vendor_type]?.name}
                      onSelect={(data) => {
                        handleOnChange("vendor_id", data.value);
                        // venderDetailsFun({ vender_type: form?.vendor_type, vender_id: data.value })

                      }}
                      placeholder={optionMap[form?.vendor_type]?.label}
                      // value={
                      //   form?.vendor_id ? optionMap[form?.vendor_type]?.list?.find((f) => f.value == form?.vendor_id) : { label: "", value: "" }
                      // }
                      value={{ label: detailsProps.vendor_detail?.name, value: detailsProps?.vendor_detail?._id }}
                      error={formError.vendor_id}
                      focus={!!formError?.vendor_id}
                      disabled={true}
                    />
                  </div>
                  {(form?.account_sub_category == 2 || form?.account_sub_category == 27 || form?.account_sub_category == 28) && (
                    <div>
                      <input
                        type="checkbox"
                        id="vehicle1"
                        name="vehicle1"
                        // value="Bike"
                        checked={form?.vendor_bank_account ? true : false}
                        disabled={form?.vendor_bank_account ? true : false}
                      // onChange={({ target: { name, checked } }) => {
                      //   setIsCheck(checked);
                      //   handleOnChange("isCheck", checked);
                      // }}
                      />
                      <label for="vehicle1"> {`${optionMap[form?.vendor_type]?.label} Bank Account`}</label>
                      <br />
                    </div>
                  )}
                  {/* {(form?.account_sub_category == 2 || form?.account_sub_category == 27 || form?.account_sub_category == 28)
                    // && isCheck 
                    && (
                      <div className="singleDiv"

                      >
                        <CustomSelect
                          label="Select Supplier Account"
                          // options={bankAccountList||[]}
                          options={[]}

                          // disabled={!isCheck}
                          openList={false}
                          value={
                            { label: detailsProps?.vendor_bank_account?.bank_name, value: detailsProps?.vendor_bank_account?.bank_name }
                          }
                          focus={!!formError?.vendor_bank_account}
                          error={formError.vendor_bank_account}
                          disabled={true}

                        />
                      </div>
                    )} */}
                    {form?.vendor_bank_account && <div className="singleDiv _bank_details_Make">
                  {!bankDetails ? <>
                    {detailsProps?.vendor_bank_account?.ifsc_code && <>
                      <span>{`Bank - ${detailsProps?.vendor_bank_account?.bank_name
                        ? `${detailsProps?.vendor_bank_account?.bank_name} `
                        : ""
                        } `}</span>
                      <span>{`A/C Name - ${detailsProps?.vendor_bank_account?.account_name
                        ? `${detailsProps?.vendor_bank_account?.account_name} `
                        : ""
                        } `}</span>
                      <span>{`A/C No - ${detailsProps?.vendor_bank_account?.account_number
                        ? `${detailsProps?.vendor_bank_account?.account_number} `
                        : ""
                        } `}</span>
                      <span>
                        {" "}
                        {`IFSC - ${detailsProps?.vendor_bank_account?.ifsc_code || ""
                          }`}
                      </span>
                    </>
                    }
                  </> : <>{bankDetails?.ifsc_code && <>
                    <span>{`Bank - ${bankDetails?.bank_name
                      ? `${bankDetails?.bank_name} `
                      : ""
                      } `}</span>
                    <span>{`A/C Name - ${bankDetails?.account_name
                      ? `${bankDetails?.account_name} `
                      : ""
                      } `}</span>
                    <span>{`A/C No - ${bankDetails?.account_number
                      ? `${bankDetails?.account_number} `
                      : ""
                      } `}</span>
                    <span>
                      {" "}
                      {`IFSC - ${bankDetails?.ifsc_code || ""
                        }`}
                    </span>
                  </>
                  }</>}
                  {!bankDetails ? <>{detailsProps?.vendor_bank_account?.upi_id && <span>
                    {" "}
                    {`UPI ID - ${detailsProps?.vendor_bank_account?.upi_id || ""
                      }`}
                  </span>}</> : <>{bankDetails?.upi_id && <span>
                    {" "}
                    {`UPI ID - ${bankDetails?.upi_id || ""
                      }`}
                  </span>}</>}


                </div>}
                </div>
              </div>
            </div>}


            <div className="_othrExp_recBx">
              <div className="_clPay_flex">
                <div className="singleDiv">
                  <div className="_attatchmentBxs">
                    <div className="__addExp_fileBx">
                      <h4>Attachment</h4>

                      {/* <div className="__addExp_fileBx"> */}
                      <input
                        type="file"
                        id="_fileUpload"
                        onChange={(e) => handleFileChange(e)}
                        disabled
                      />
                      <label htmlFor="_fileUpload" className="_uploadBtn">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="19"
                          viewBox="0 0 20 19"
                          fill="none"
                        >
                          <path
                            d="M5 0C6.28846 7.44425e-05 7.52716 0.497542 8.45778 1.38866C9.38839 2.27978 9.93908 3.49575 9.995 4.783L10 5V16C10.0008 16.7809 9.69698 17.5313 9.15323 18.0918C8.60948 18.6523 7.86861 18.9787 7.08804 19.0016C6.30747 19.0245 5.54873 18.7422 4.97303 18.2145C4.39733 17.6869 4.05006 16.9556 4.005 16.176L4 16V6C4.00028 5.74512 4.09788 5.49997 4.27285 5.31463C4.44782 5.1293 4.68695 5.01776 4.94139 5.00283C5.19584 4.98789 5.44638 5.07067 5.64183 5.23426C5.83729 5.39785 5.9629 5.6299 5.993 5.883L6 6V16C6.00028 16.2549 6.09788 16.5 6.27285 16.6854C6.44782 16.8707 6.68695 16.9822 6.94139 16.9972C7.19584 17.0121 7.44638 16.9293 7.64183 16.7657C7.83729 16.6021 7.9629 16.3701 7.993 16.117L8 16V5C8.00075 4.21909 7.69698 3.46867 7.15323 2.90818C6.60948 2.34769 5.86861 2.02132 5.08804 1.9984C4.30747 1.97548 3.54873 2.25784 2.97303 2.78546C2.39733 3.31309 2.05006 4.0444 2.005 4.824L2 5V14C1.99972 14.2549 1.90212 14.5 1.72715 14.6854C1.55218 14.8707 1.31305 14.9822 1.05861 14.9972C0.804163 15.0121 0.553621 14.9293 0.358167 14.7657C0.162714 14.6021 0.0371036 14.3701 0.00699997 14.117L0 14V5C0 3.67392 0.526784 2.40215 1.46447 1.46447C2.40215 0.526784 3.67392 0 5 0ZM13 14H15C15.2549 14.0003 15.5 14.0979 15.6854 14.2728C15.8707 14.4478 15.9822 14.687 15.9972 14.9414C16.0121 15.1958 15.9293 15.4464 15.7657 15.6418C15.6021 15.8373 15.3701 15.9629 15.117 15.993L15 16H13C12.7451 15.9997 12.5 15.9021 12.3146 15.7272C12.1293 15.5522 12.0178 15.313 12.0028 15.0586C11.9879 14.8042 12.0707 14.5536 12.2343 14.3582C12.3979 14.1627 12.6299 14.0371 12.883 14.007L13 14ZM13 10H18.5C18.7549 10.0003 19 10.0979 19.1854 10.2728C19.3707 10.4478 19.4822 10.687 19.4972 10.9414C19.5121 11.1958 19.4293 11.4464 19.2657 11.6418C19.1021 11.8373 18.8701 11.9629 18.617 11.993L18.5 12H13C12.7451 11.9997 12.5 11.9021 12.3146 11.7272C12.1293 11.5522 12.0178 11.313 12.0028 11.0586C11.9879 10.8042 12.0707 10.5536 12.2343 10.3582C12.3979 10.1627 12.6299 10.0371 12.883 10.007L13 10ZM13 6H18.5C18.7549 6.00028 19 6.09788 19.1854 6.27285C19.3707 6.44782 19.4822 6.68695 19.4972 6.94139C19.5121 7.19584 19.4293 7.44638 19.2657 7.64183C19.1021 7.83729 18.8701 7.9629 18.617 7.993L18.5 8H13C12.7451 7.99972 12.5 7.90212 12.3146 7.72715C12.1293 7.55218 12.0178 7.31305 12.0028 7.05861C11.9879 6.80416 12.0707 6.55362 12.2343 6.35817C12.3979 6.16271 12.6299 6.0371 12.883 6.007L13 6ZM13 2H18.5C18.7549 2.00028 19 2.09788 19.1854 2.27285C19.3707 2.44782 19.4822 2.68695 19.4972 2.94139C19.5121 3.19584 19.4293 3.44638 19.2657 3.64183C19.1021 3.83729 18.8701 3.9629 18.617 3.993L18.5 4H13C12.7451 3.99972 12.5 3.90212 12.3146 3.72715C12.1293 3.55218 12.0178 3.31305 12.0028 3.05861C11.9879 2.80416 12.0707 2.55362 12.2343 2.35817C12.3979 2.16271 12.6299 2.0371 12.883 2.007L13 2Z"
                            fill="#1956F6"
                          />
                        </svg>
                        <span>{loading ? "Uploadding" : "Add File"}</span>
                      </label>
                      {formError?.file && (
                        <span className="input_drop_error">
                          {formError?.file}
                        </span>
                      )}
                    </div>
                    <div className="img_fnex_src">
                      {form?.file?.length > 0 &&
                        form?.file?.map((el, index) => {
                          return (
                            <>
                              <div className="pos-relative">
                                <img
                                  className="_pdfIcon_sigxe"
                                  src={`${masterData?.s3_url}${el?.path}`}
                                  alt=""
                                />
                                <span className="_clDel_icon">
                                  <IoCloseCircle

                                  />
                                </span>
                              </div>
                            </>
                          );
                        })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="_balSuccess">
            <p>Balance</p>
  
            <p>
              {(props?.transactionList?.freight_summary?.freight_summary
                ?.balance - form?.amount).toFixed(2)}
            </p>
          </div> */}
      </CommonCanvas>
      {isOpenFuelModal && <AddEditModal {...openZoneModal} />}
    </div>
  );
};

export default ExpenseMarket;
